import GoAiguaCheckbox from "components/generic/goaiguacheckbox";
import { useEffect, useState } from "react";

const GroupCheckboxCellRenderer = (props: any) => {
  const [checked, setChecked] = useState<
    "checked" | "partially-checked" | "not-checked"
  >("not-checked");
  const [refresh, setRefresh] = useState<boolean>(false);

  const retrieveCheckboxStatus = () => {
    if (props.colDef && props.data !== null && props.data !== undefined) {
      const columnName = props.colDef.field;
      return props.data[columnName];
    } else {
      return false;
    }
  };

  const onCheckboxClickCallback = () => {
    if (props.colDef && props.data) {
      const columnName = props.colDef.field;
      props.data[columnName] = !props.data[columnName];
      props.changeCheckboxes()
      setRefresh(true);
    }
  };

  useEffect(() => {
    props.node.refreshNode = () => setRefresh(true);
  }, []);

  useEffect(() => {
    setChecked(retrieveCheckboxStatus() ? "checked" : "not-checked");
    setRefresh(false);
  }, [props.data, refresh]);

  const renderCheckboxIfValue = () => {
    if (props.value !== undefined && props.value !== null) {
      return (
        <div className="c-checkbox-cell-renderer">
          <div className="c-checkbox-cell-renderer__checkbox">
            <GoAiguaCheckbox
              checkedStatus={checked}
              setCheckedStatus={onCheckboxClickCallback}
            />
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };
  return renderCheckboxIfValue();
};

export default GroupCheckboxCellRenderer;
